import React from "react";
import { EditAction } from "components/buttons";
import { Restricted, permissions } from "components/auth";
import { DeleteActionWithModal } from "components/buttons";
import { useMutation } from "@apollo/react-hooks";
import PropTypes from "prop-types";

const ActionButtons = ({ id, customerId, name, mutation, history }) => {
  const [deleteSource] = useMutation(mutation);

  return (
    <>
      <Restricted permissions={[permissions.source_manage]}>
        <EditAction url={`/source/edit/${id}`} />
        <DeleteActionWithModal
          actionButton
          urlOnSuccess="/source/list"
          history={history}
          mutation={deleteSource}
          mutationVariables={{
            sourceId: id,
            customerId,
          }}
          elementNameInResult="deleteSource"
          elementToDelete={name}
        />
      </Restricted>
    </>
  );
};

ActionButtons.propTypes = {
  /**
   * Id del elemento sobre el que se realiza la acción
   **/
  id: PropTypes.string,
  /**
   * Id del customer
   **/
  customerId: PropTypes.string,
  /**
   * Nombre del elemento
   **/
  name: PropTypes.string,
  /**
   * Query gql de borrado del elemento
   **/
  mutation: PropTypes.object.isRequired,
};

export default ActionButtons;
